/* index.js */

"use strict";

let JsonComparator = require("./sys/jnib/lib/json-comparator/JsonComparator");
let jsonDiff = require("deep-diff");
let _ = require("lodash");
let JsonSort = require("./sys/jnib/lib/json-comparator/OrderJson");
JsonComparator.initialize(jsonDiff, _, console);
JsonSort.initialize(_, console);

module.exports = {
    JsonComparator: JsonComparator,
    JsonSort: JsonSort,
};
